export default __webpack_public_path__ + "static/media/Nice_Shirt_Falls_HeadShot.8679b3bc.jpg";